import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Theme } from "theme";

export const BurgerMenuContainer = styled.div`
  display: flex;
  justify-content: stretch;
  align-items: stretch;
`;

export const BurgerButton = styled("button")<{ menuOpen: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: transparent;
  row-gap: 5px;
  border: none;
  cursor: pointer;
  padding: 0 10px;
  z-index: 10;

  &:focus {
    outline: none;
  }

  &:hover {
    background: ${Theme.navHoverBackground};
  }

  div {
    width: 1.5rem;
    height: 0.2rem;
    background: white;
    border-radius: 4px;
    position: relative;
  }

  div.bar1 {
    ${({ menuOpen }) =>
      menuOpen && "transform: translate(0, 8px) rotate(-45deg)"};
  }

  div.bar2 {
    ${({ menuOpen }) => menuOpen && "opacity: 0"};
  }

  div.bar3 {
    ${({ menuOpen }) =>
      menuOpen && "transform: translate(0, -8.5px) rotate(45deg)"}
  }
`;

export const MenuContainer = styled.nav<{ open: boolean }>`
  position: fixed;
  overflow-y: scroll;
  transition: transform 0.3s ease-in-out;
  background-color: ${Theme.burgerMenuBackground};
  z-index: 5;
  height: 100vh;
  top: 0;
  left: 0;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(-100%)")};
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 70px;
`;

export const MenuNavItem = styled(NavLink)`
  text-align: center;
  color: ${Theme.navForeground};
  padding: 5px 60px;
  text-decoration: none;
  font-size: 13pt;
  border-right: 4px solid transparent;
  cursor: pointer;

  &:hover {
    background: ${Theme.navHoverBackground};
    color: ${Theme.navHoverForeground};
  }

  &.active {
    background: ${Theme.navActiveBackground};
    color: ${Theme.navActiveForeground};
    border-color: ${Theme.navActiveForeground};
    &:hover {
      background: ${Theme.navActiveHoverBackground};
    }
`;
